/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import './formDatePicker.css';

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormDataPicker = (props) => {
  const {
    validation, errorText, label, helpText, value, onChange,id,cssForm,disabled
  } = props;

  const [valueState, setValueState] = useState(value);
  if (value !== valueState) {
    setValueState(value);
  }

  return (
    <div className={(cssForm?cssForm:`form-group row text-${validation}`)}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        <DatePicker
          id={id}
          disabled={disabled}
          className="form-control"
          selected={valueState === '' || valueState === 0 ? undefined : new Date(valueState)}
          onChange={(date) => onChange({ target: { value: date === null ? 0 : date.getTime() } })}
          disabledKeyboardNavigation
          dateFormat="MM/dd/yyyy HH:mm"
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          timeCaption="time"
          popperPlacement="top-end"
          popperModifiers={{
            offset: { enabled: true, offset: '5px, 10px' },
            preventOverflow: {
              enabled: true,
            }
          }}
          popperProps={{
            positionFixed: true // Used to force the molecule to show above the component
          }}
        />
        { (validation === FormValidation.ERROR || validation === FormValidation.WARNING)
          && (
            <small className="form-text">{errorText}</small>
          )}
      </div>
    </div>
  );
};

FormDataPicker.propTypes = {
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
};

FormDataPicker.defaultProps = {
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  helpText: '',
  value: '',
  onChange: () => {},
};

export default FormDataPicker;
